import { BUTTER, CORAL, INK, LILAC, MINT, PAPER, PEACH, SHAPE_COLORS, SKY, lerpColor } from '../../color';
import type { World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const world: World = {
  id: 'arraial',
  name: 'Arraial',
  seed: 'b',
  legacy: true,
  hue: 285,
  ceil: 0x342c3b,
  font: 'Shrikhand',
  fontFile: 'shrikhand-400.woff2',
  fontWeight: '400',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.42,
  fillAlpha: 0.64,
  palette: {
    bg: lerpColor(INK, 0x000000, 0.4),
    ink: lerpColor(INK, 0x000000, 0.55),
    rim: lerpColor(PAPER, BUTTER, 0.35),
    held: PEACH,
    heldShade: CORAL,
    heldLight: lerpColor(PAPER, BUTTER, 0.4),
    incoming: SHAPE_COLORS,
    spot: BUTTER,
    path: lerpColor(PAPER, INK, 0.45),
    text: PAPER,
    sparks: [BUTTER, PEACH, MINT, SKY, LILAC, CORAL],
  },
  burst: { count: 12, speed: 0.6, drag: 3, gravity: 0.45, spin: 7, life: 1, sizeMin: 0.01, sizeMax: 0.022 },
  dress,
  fx,
  paint,
};

export default world;
